module.exports = __webpack_public_path__ + "img/beaubatons_carriage.1467a547.jpg";